import { render, staticRenderFns } from "./ReceptionObservationPage.vue?vue&type=template&id=483e9ae8&"
import script from "./ReceptionObservationPage.vue?vue&type=script&lang=js&"
export * from "./ReceptionObservationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports